import { _ep0, _mw7, command } from "../commandBuilder";
import { GetObject$ } from "../schemas/schemas_0";
export class GetObjectCommand extends command(_ep0, _mw7, "GetObject", GetObject$) {
}
